const isVerbose = typeof localStorage !== 'undefined' && localStorage.getItem('debug') === 'true';

export const logger = {
  debug: (..._args: unknown[]) => {
    // Enable with: localStorage.setItem('debug', 'true')
  },
  info: (..._args: unknown[]) => {},
  warn: (..._args: unknown[]) => {},
  error: (...args: unknown[]) => {
    console.error(...args);
  },
};
